export const catbreeds = [
  {
    id: "197",
    name: "Persian",
  },
  {
    id: "201",
    name: "Maine Coon",
  },
  {
    id: "214",
    name: "Calico",
  },
  {
    id: "228",
    name: "Devon Rex",
  },
  {
    id: "232",
    name: "No Choice",
  },
];
